import React, { useEffect } from "react";
import { useFormikContext } from "formik";

interface CreateServiceFormEffectsProps {
    pickedCategoryId: number | null;
    runJoy: boolean;
    setRun: React.Dispatch<React.SetStateAction<boolean>>;
}

interface CreateServiceFormValues {
    category: number | null;
    onlineBooking?: boolean;
}

const CreateServiceFormEffects: React.FC<CreateServiceFormEffectsProps> = ({ pickedCategoryId, runJoy, setRun }) => {
    const { setFieldValue } = useFormikContext<CreateServiceFormValues>();

    useEffect(() => {
        setFieldValue("category", pickedCategoryId);
    }, [pickedCategoryId, setFieldValue]);

    useEffect(() => {
        setFieldValue("onlineBooking", !!runJoy);
        setRun(!!runJoy);
    }, [runJoy, setFieldValue, setRun]);

    return null;
};

export default CreateServiceFormEffects;
